import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Profile } from 'src/app/Models/profile.interface';

@Component({
  selector: 'app-contact-sheet',
  templateUrl: './contact-sheet.component.html',
  styleUrls: ['./contact-sheet.component.css']
})
export class ContactSheetComponent implements OnInit {
  contact: Profile
  openProfileSheet: Function;
  constructor(
    // private afs: AngularFirestore,
    // private db: AngularFireDatabase,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: {
      contact: Profile,
      openProfileSheet: Function
    },
    private _bottomSheetRef: MatBottomSheetRef<ContactSheetComponent>,
    ) {
      this.contact = data.contact
      this.openProfileSheet = data.openProfileSheet
    }

  ngOnInit(): void {
  }

  startConversation(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();

  }

  openProfile(event: MouseEvent): void {
    event.preventDefault();
    this._bottomSheetRef.dismiss();
    setTimeout(() => this.openProfileSheet(event, this.contact), 2000)
    
  }
}

